module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newActivity"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    活动管理 >\n    "), (_vm.edit === false) ? _c('span', [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "activityForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.activityForm,
      "label-width": "170px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "activityTitle",
    model: {
      value: (_vm.activityForm.name),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "name", $$v)
      },
      expression: "activityForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动类型:",
      "prop": "activityType",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "activityType",
    model: {
      value: (_vm.activityForm.activityType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "activityType", $$v)
      },
      expression: "activityForm.activityType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "跑步奖励",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他活动",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "室内锻炼",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图:",
      "prop": "bigImageUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "show-file-list": false,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.chenggong
    }
  }, [(_vm.activityForm.bigImageUrl) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.activityForm.bigImageUrl
    }
  }) : _c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n                  将文件拖到此处，或\n                  "), _c('em', [_vm._v("点击上传")])])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品类型:",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "activityType",
    model: {
      value: (_vm.activityForm.prizeType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "prizeType", $$v)
      },
      expression: "activityForm.prizeType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "必中奖品",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "随机奖品",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "限量奖品",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动是否开启报名:",
      "prop": "openJoin",
      "required": ""
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.activityForm.openJoin),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "openJoin", $$v)
      },
      expression: "activityForm.openJoin"
    }
  }, [_vm._v("不开启报名")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.openJoin),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "openJoin", $$v)
      },
      expression: "activityForm.openJoin"
    }
  }, [_vm._v("开启报名")]), _vm._v(" "), (_vm.activityForm.openJoin == '1') ? _c('el-input', {
    staticStyle: {
      "width": "200px",
      "display": "inline-block",
      "margin-left": "10px"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入名额"
    },
    model: {
      value: (_vm.activityForm.maxJoinCount),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "maxJoinCount", $$v)
      },
      expression: "activityForm.maxJoinCount"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "click-events",
    attrs: {
      "label": "点击事件",
      "prop": "clickType",
      "required": ""
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.activityForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "clickType", $$v)
      },
      expression: "activityForm.clickType"
    }
  }, [_vm._v("无跳转")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "clickType", $$v)
      },
      expression: "activityForm.clickType"
    }
  }, [_vm._v("跳转至URL：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.activityForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "clickType", $$v)
      },
      expression: "activityForm.clickType"
    }
  }, [_vm._v("跳转至已有文章：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.activityForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "clickType", $$v)
      },
      expression: "activityForm.clickType"
    }
  }, [_vm._v("跳转至已有话题：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.activityForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "clickType", $$v)
      },
      expression: "activityForm.clickType"
    }
  }, [_vm._v("跳转至微信小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "7"
    },
    model: {
      value: (_vm.activityForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "clickType", $$v)
      },
      expression: "activityForm.clickType"
    }
  }, [_vm._v("跳转至支付宝小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "5"
    },
    model: {
      value: (_vm.activityForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "clickType", $$v)
      },
      expression: "activityForm.clickType"
    }
  }, [_vm._v("跳转至音频：")]), _vm._v(" "), (_vm.shieldArray.indexOf(_vm.activityForm.clickType) > -1) ? _c('el-input', {
    staticClass: "activityTitle",
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.activityForm.activityUrl),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "activityUrl", $$v)
      },
      expression: "activityForm.activityUrl"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activityForm.clickType == '4') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "prop": "wxAppId",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.activityForm.wxAppId),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "wxAppId", $$v)
      },
      expression: "activityForm.wxAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址：",
      "prop": "wxAppUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.activityForm.wxAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "wxAppUrl", $$v)
      },
      expression: "activityForm.wxAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.clickType == '7') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "prop": "aliAppId",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.activityForm.aliAppId),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "aliAppId", $$v)
      },
      expression: "activityForm.aliAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址：",
      "prop": "aliAppUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.activityForm.aliAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "aliAppUrl", $$v)
      },
      expression: "activityForm.aliAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.clickType == '5') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "专辑ID：",
      "prop": "albumId",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写专辑ID"
    },
    model: {
      value: (_vm.activityForm.albumId),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "albumId", $$v)
      },
      expression: "activityForm.albumId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    attrs: {
      "label": "主播名称：",
      "prop": "nickName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写主播名称"
    },
    model: {
      value: (_vm.activityForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "nickName", $$v)
      },
      expression: "activityForm.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "单曲数：",
      "prop": "albumCount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写单曲数",
      "type": "number"
    },
    model: {
      value: (_vm.activityForm.albumCount),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "albumCount", $$v)
      },
      expression: "activityForm.albumCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "是否付费：",
      "prop": "isPaid",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "isPaid", $$v)
      },
      expression: "activityForm.isPaid"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.activityForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "isPaid", $$v)
      },
      expression: "activityForm.isPaid"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "APP跑步详情处提示：",
      "prop": "runShow"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.runShow),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "runShow", $$v)
      },
      expression: "activityForm.runShow"
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.activityForm.runShow),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "runShow", $$v)
      },
      expression: "activityForm.runShow"
    }
  }, [_vm._v("开启")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动列表展示：",
      "prop": "listShow"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.listShow),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "listShow", $$v)
      },
      expression: "activityForm.listShow"
    }
  }, [_vm._v("展示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.activityForm.listShow),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "listShow", $$v)
      },
      expression: "activityForm.listShow"
    }
  }, [_vm._v("不展示")])], 1), _vm._v(" "), (_vm.activityForm.runShow == '0') ? _c('el-form-item', {
    staticClass: "right",
    attrs: {
      "label": "活动图标：",
      "prop": "smallImageUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess,
      "show-file-list": false
    }
  }, [(_vm.activityForm.smallImageUrl) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.activityForm.smallImageUrl
    }
  }) : _c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n                  将文件拖到此处，或\n                  "), _c('em', [_vm._v("点击上传")])])])])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " 中奖方式:",
      "prop": "rewardType",
      "required": ""
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.rewardType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "rewardType", $$v)
      },
      expression: "activityForm.rewardType"
    }
  }, [_vm._v("每人每天中奖")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.activityForm.rewardType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "rewardType", $$v)
      },
      expression: "activityForm.rewardType"
    }
  }, [_vm._v("活动期间内每人中奖")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.activityForm.rewardType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "rewardType", $$v)
      },
      expression: "activityForm.rewardType"
    }
  }, [_vm._v("所有奖励使用后可再次中奖")]), _vm._v(" "), (_vm.activityForm.rewardType != '3') ? _c('div', [_c('el-input', {
    staticClass: "limitCount",
    attrs: {
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.activityForm.limitCount),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "limitCount", $$v)
      },
      expression: "activityForm.limitCount"
    }
  }), _vm._v("\n                次\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起止日期:",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.activityForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "startTime", $$v)
      },
      expression: "activityForm.startTime"
    }
  }), _vm._v(" "), _vm._v("\n            至\n            "), _vm._v(" "), _c('el-date-picker', {
    staticClass: "qizhiDate",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.activityForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.activityForm, "endTime", $$v)
      },
      expression: "activityForm.endTime"
    }
  })], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.activityForm.schObj,
      "isRoot": _vm.isRoot
    },
    on: {
      "changeVal": _vm.getVal
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.activityForm.activityType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "针对的跑步类型:"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.runType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "runType", $$v)
      },
      expression: "activityForm.activityRunDetail.runType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("计分跑")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("自由跑")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("一起跑")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.activityType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "是否屏蔽跑步结束页广告:"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.activityForm.activityRunDetail.isBindEndAd),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "isBindEndAd", $$v)
      },
      expression: "activityForm.activityRunDetail.isBindEndAd"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.activityType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "APP跑步结果页活动入口:"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.activityForm.activityRunDetail.runEndMsgType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "runEndMsgType", $$v)
      },
      expression: "activityForm.activityRunDetail.runEndMsgType"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "0"
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "1"
    }
  }, [_vm._v("开启")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.activityRunDetail.runEndMsgType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "入口图片:"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.chenggong2,
      "show-file-list": false
    }
  }, [(_vm.activityForm.activityRunDetail.msgPicUrl) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.activityForm.activityRunDetail.msgPicUrl
    }
  }) : _c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n                  将文件拖到此处，或\n                  "), _c('em', [_vm._v("点击上传")])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.activityType == '1') ? _c('el-form-item', {
    staticClass: "click-events",
    attrs: {
      "label": "点击事件:"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickType", $$v)
      },
      expression: "activityForm.activityRunDetail.clickType"
    }
  }, [_vm._v("无跳转")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickType", $$v)
      },
      expression: "activityForm.activityRunDetail.clickType"
    }
  }, [_vm._v("跳转至URL：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickType", $$v)
      },
      expression: "activityForm.activityRunDetail.clickType"
    }
  }, [_vm._v("跳转至已有文章：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickType", $$v)
      },
      expression: "activityForm.activityRunDetail.clickType"
    }
  }, [_vm._v("跳转至已有话题：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickType", $$v)
      },
      expression: "activityForm.activityRunDetail.clickType"
    }
  }, [_vm._v("跳转至微信小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "7"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickType", $$v)
      },
      expression: "activityForm.activityRunDetail.clickType"
    }
  }, [_vm._v("跳转至支付宝小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "5"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickType),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickType", $$v)
      },
      expression: "activityForm.activityRunDetail.clickType"
    }
  }, [_vm._v("跳转至音频：")]), _vm._v(" "), (
    _vm.shieldArray2.indexOf(
      _vm.activityForm.activityRunDetail.clickType
    ) > -1
  ) ? _c('el-input', {
    staticClass: "activityTitle",
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.clickUrl),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "clickUrl", $$v)
      },
      expression: "activityForm.activityRunDetail.clickUrl"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.activityRunDetail.clickType == '4') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.wxAppId),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "wxAppId", $$v)
      },
      expression: "activityForm.activityRunDetail.wxAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.wxAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "wxAppUrl", $$v)
      },
      expression: "activityForm.activityRunDetail.wxAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.activityRunDetail.clickType == '7') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.aliAppId),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "aliAppId", $$v)
      },
      expression: "activityForm.activityRunDetail.aliAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.aliAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "aliAppUrl", $$v)
      },
      expression: "activityForm.activityRunDetail.aliAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activityForm.activityRunDetail.clickType == '5') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "专辑ID：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写专辑ID"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.albumId),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "albumId", $$v)
      },
      expression: "activityForm.activityRunDetail.albumId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    attrs: {
      "label": "主播名称：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写主播名称"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.nickName),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "nickName", $$v)
      },
      expression: "activityForm.activityRunDetail.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "单曲数：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写单曲数",
      "type": "number"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.albumCount),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "albumCount", $$v)
      },
      expression: "activityForm.activityRunDetail.albumCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "是否付费：",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "isPaid", $$v)
      },
      expression: "activityForm.activityRunDetail.isPaid"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "isPaid", $$v)
      },
      expression: "activityForm.activityRunDetail.isPaid"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), (['1', '4', '7'].indexOf(_vm.activityForm.activityRunDetail.clickType) > -1) ? _c('div', {
    staticClass: "popup-prompt-wrap"
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否弹窗提示",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "popup-prompt-row"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.activityForm.activityRunDetail.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "isPopup", $$v)
      },
      expression: "activityForm.activityRunDetail.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), (_vm.activityForm.activityRunDetail.isPopup === 1) ? _c('el-input', {
    staticClass: "popup-prompt-input",
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写弹窗内容，最多20个字"
    },
    model: {
      value: (_vm.activityForm.activityRunDetail.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.activityForm.activityRunDetail, "popupContent", $$v)
      },
      expression: "activityForm.activityRunDetail.popupContent"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label"
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupPromptExampleImg,
      "alt": "弹窗示例"
    }
  })])], 1)])], 1) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70a2a67a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/activity/newActivity.vue
// module id = 1069
// module chunks = 0